var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHairOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.612,
    height: 24.973,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-282 15295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(282 -15295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287 -15289.886)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.331,24.973a15.884,15.884,0,0,0,3.313-1.914,9.767,9.767,0,0,0,3.969-6.16A6.749,6.749,0,0,0,119.8,9.554a16.272,16.272,0,0,1-4.526-3.237,10.852,10.852,0,0,1-2.837-5.082c-.047-.206-.085-.374.2-.459A14.593,14.593,0,0,1,120.85.449,8.9,8.9,0,0,1,126.5,4.96a16.4,16.4,0,0,1,1.992,9.52,10.1,10.1,0,0,1-4.232,7.311,17.688,17.688,0,0,1-7.449,3.1c-.158.03-.318.053-.477.079",
    transform: "translate(-103.955 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.928,14.31c-.368.81-.762,1.6-1.093,2.423a19.9,19.9,0,0,0-1.523,8.805,15.6,15.6,0,0,0,3.624,9.086c.435.531.908,1.032,1.422,1.612a3.18,3.18,0,0,1-.334-.128,18.671,18.671,0,0,1-6.852-5.9,11.394,11.394,0,0,1-.525-12.593A6.642,6.642,0,0,1,6.6,14.307a1.446,1.446,0,0,1,.225-.015.551.551,0,0,1,.106.018",
    transform: "translate(0 -13.217)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairOff);
export default __webpack_public_path__ + "static/media/hairOFF.0662cff7da80fbae5b8033a1f62edb7d.svg";
export { ForwardRef as ReactComponent };